import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUserAuth } from '../context/UserAuthContext';
import { Link } from 'react-router-dom';
import { MdDelete, MdEditSquare } from 'react-icons/md';
import './blog.css'
import axios from 'axios';

const BlogList = () => {
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 20;

    const getBlog = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`https://backend-mbbs.onrender.com/api/blog/data`);
            setData(res.data.data);
            setTotalPages(res.data.pagination.totalPages);
            setLoading(false);
        } catch (err) {
            console.log('error', err);
            setLoading(false);
        }
    };

    useEffect(() => {
        getBlog();
    }, [page]);

    const deletebtnHandler = async (blog_id) => {
        const choice = window.confirm('Are you sure want to delete?');
        if (choice) {
            try {
                await axios.delete(`${base_url}/api/v1/blogs/${blog_id}`);
                toast.success("Blog deleted successfully");
                getBlog();
            } catch (err) {
                console.log(err);
            }
        }
    };

    return (
        <>
            <div className="page-wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className='card-header row d-flex justify-content-between align-items-center'>
                                    {/* <div className='col-md-4'>
                                        <Link to="/dashboard/blog" className='btn btn-primary btn-sm'> + Add Blog </Link>
                                    </div> */}
                                    <h4>Blog List</h4>
                                </div>
                                <div className='card-body'>
                                    <div className='table-responsive'>
                                        <table className='table table-bordered shadow-sm mt-3' cellPadding={5}>
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Image</th>
                                                    <th>Title</th>
                                                    <th>Date</th>
                                                    {/* <th>Action</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        {[...Array(9)].map((_, i) => (
                                                            <td key={i}><Skeleton count={1} /></td>
                                                        ))}
                                                    </tr>
                                                ) : data.length > 0 ? (
                                                    data.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>{(page - 1) * limit + index + 1}</td>
                                                            <td>
                                                                <div className='d-flex align-items-center'>
                                                                    <img src={item.image} alt='img' style={{ height: '60px', width: '60px', borderRadius: '10px', marginRight: '5px' }} />
                                                                </div>
                                                            </td>
                                                            <td>{item.title}</td>
                                                            <td>{item.date}</td>
                                                            {/* <td>{item.cat_slug}</td>
                                                            <td>{item.created_at}</td> */}
                                                            {/* <td>
                                                                <Link to={`/dashboard/edit-blog/${item.id}`}>
                                                                    <MdEditSquare size={24} style={{ color: 'green' }} />
                                                                </Link>
                                                                <button className='btn'>
                                                                    <MdDelete size={24} style={{ color: 'red' }} onClick={() => deletebtnHandler(item.id)} />
                                                                </button>
                                                            </td> */}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr className='text-center text-danger'>
                                                        <td colSpan={9}>Blog not found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                                        <button
                                            className="btn btn-sm btn-outline-secondary"
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            Previous
                                        </button>
                                        <span>Page {page} of {totalPages}</span>
                                        <button
                                            className="btn btn-sm btn-outline-secondary"
                                            disabled={page === totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    )
}

export default BlogList;